import * as React from "react";
export var FormLayoutContext = React.createContext({
    layout: "two-column",
});
export var useFormLayoutContext = function () { return React.useContext(FormLayoutContext); };
